import React from "react";
import img from "./img/bg.avif";
import imgJpg from "./img/bg.jpg";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const url = window.location.hostname;
  const caproig = "caproig";
  const pedralbes = "pedralbes";
  let text = false;
  let castellano = false;

  let promoFinalizada = false;
  const iconica = "iconica";
  const universal = "universal";
  const festivalalma = "festivalalma";
  const sorteoalma = "sorteofestivalalma";
  const forms = "forms";

  if(url.includes(iconica) || url.includes(universal) || url.includes(forms)) {
    castellano = true;
  }


  return (
    <div className="home-container">
      <div>
        {promoFinalizada ?
        <>
            {castellano ?
              <>
                <div className="title-container">
                  <h1>La promoción ha finalizado</h1>
                </div>
              </>
              :
              <>
                <div className="title-container">
                  <h1>La promoció ha finalitzat</h1>
                  <p>La promoción ha finalizado</p>
                </div>
              </>
            }
        </>
        :
        <>
          {castellano ?
            <>
               <div className="title-container">
                    <h1>¡Participa para conseguir nuestro tratamiento exclusivo <strong>glass skin!</strong></h1>
                    <div className="text-container" style={{ marginBottom: "15px" }}>
                      <p>Rellena este breve formulario para acceder a la promoción exclusiva del tratamiento estético GLASS SKIN y recibe una crema age element® de regalo en el centro.</p>
                    </div>
                </div> 
            </>
            : 
            <>
                <div className="title-container">
                    <h1>Participa per aconseguir el nostre tractament exclusiu <strong>glass skin!</strong></h1>
                    <p>¡Participa para conseguir nuestro tratamiento exclusivo <strong>glass skin!</strong></p>
                  </div>
                  <div className="text-container" style={{ marginBottom: "15px" }}>
                    <p>Omple aquest breu formulari per accedir a la promoció exclusiva del tractament estètic GLASS SKIN i rep una crema age element® de regal al centre.</p>
                    <p>Rellena este breve formulario para acceder a la promoción exclusiva del tratamiento estético GLASS SKIN y recibe una crema age element® de regalo en el centro.</p>
                  </div>
            </>
          }
          <div className="image-container">
            <picture>
              <source srcSet={img} type="image/avif" />
              <source srcSet={imgJpg} type="image/jpeg" />
              <img src={img} alt="Mesoestetic products" />
            </picture>
          </div>
          {castellano ?
            <>
              <Link to="/questionnaire">
                <div className="primary-btn">
                  <span>¡Empezar!</span>
                </div>
              </Link>
            </>
            :
            <>
              <Link to="/questionnaire">
                <div className="primary-btn">
                  <span>Començar!</span> /¡Empezar!
                </div>
              </Link>
            </>
          }
        </>          
        }
        
      </div>
    </div>
  );
};

export default Home;
